import { useQuery } from '@tanstack/react-query';

import { hrApi } from '@/api';
import { queryKeys, tierOptions } from '@/lib/query';

/** Linked employees.id for the signed-in user (ESS profile), when available. */
export function useCurrentEmployeeId() {
  const { data } = useQuery({
    queryKey: queryKeys.hr.essProfile(),
    queryFn: async () => {
      try {
        return await hrApi.essProfile();
      } catch {
        return null;
      }
    },
    ...tierOptions('operational'),
    staleTime: 5 * 60_000,
  });

  return data?.employee?.id ?? null;
}
